import LogDateTimeInput from "../../../components/LogDateTimeInput";
import { localLogDateTime, logDateTimePayload } from "../../../utils/logDateTime";
import { Button, message, Radio, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SelectInput from "../../../components/SelectInput";
import AppInput from "../../../components/AppInput";
import TextArea from "antd/es/input/TextArea";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import { garbageType, methodofDisposal } from "../../../Data/data";
import useUserData from "../../../hooks/useUserData";
import useDocumentUpload from "../../../hooks/useDocumentUpload";
import { UploadOutlined } from "@ant-design/icons";
import SecurityCodeModal from "../../../components/SecurityCodeModal";

function EditGarbageLog() {
  const navigate = useNavigate();
  const { garbage_id } = useParams();
  const user = useUserData();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [captureNow, setCaptureNow] = useState(false);
  const [staff_dashboard, set_staff_dashboard] = useState("");
  const [garbage_type, set_garbage_type] = useState("");
  const [qtty_disposed, set_qtty_disposed] = useState("");
  const [method_of_disposal, set_method_of_disposal] = useState("");
  const [if_disposed, set_If_disposed] = useState(false);
  const [free_Text, set_Free_Text] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [reviewed, setReviewed] = useState(false);
  const [recordVoyage, setRecordVoyage] = useState(null);
  const [logDate, set_LogDate] = useState(null);
  const [position, setPosition] = useState("");
  const [initialDocument, setInitialDocument] = useState([]);
  const [digitalSignatureIncharge, setDigitalSignatureIncharge] = useState("");
  const { documentList, handleDocumentChange, getFilesForUpload } =
    useDocumentUpload(initialDocument);
  const [initialFormState, setInitialFormState] = useState({});
  const [soft_delete, set_soft_delete] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    VIEW_GARBAGE_LOGBOOK_APIS();
  }, []);

  const VIEW_GARBAGE_LOGBOOK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", recordVoyage);
    FORM_DATA.append("record_id", atob(garbage_id));
    FORM_DATA.append("request_type", "view");
    FORM_DATA.append("garbage_part", "1");
    post(ApiURL.garbage_record_details, FORM_DATA).then((res) => {
      if (res?.status === true) {
        const garbageData = res?.record_data;
        set_garbage_type(garbageData?.garbage_type);
        set_qtty_disposed(garbageData?.quantity_disposed);
        set_method_of_disposal(garbageData?.method_of_disposal);
        set_If_disposed(garbageData?.disposed ? "yes" : "no");
        set_Free_Text(garbageData?.comment);
        setSubmitStatus(res?.submit_status);
        setCanEdit(res?.can_edit === true);
        setReviewed(Boolean(garbageData?.reviewed_by_master));
        setRecordVoyage(garbageData?.voyage_id);
        set_LogDate(garbageData?.log_date_time);
        setDigitalSignatureIncharge(garbageData?.signature);
        setPosition(garbageData?.position);
        setInitialDocument(garbageData?.files);
        set_soft_delete(garbageData?.soft_delete);
        // Save initial form state for change tracking
        setInitialFormState({
          garbage_type: garbageData?.garbage_type,
          qtty_disposed: garbageData?.quantity_disposed,
          method_of_disposal: garbageData?.method_of_disposal,
          disposed: garbageData?.disposed ? "yes" : "no",
          comment: garbageData?.comment,
          log_date_time: garbageData?.log_date_time,
          signature: garbageData?.signature,
          position: garbageData?.position,
        });
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  const UPDATE_GARBAGE_LOGBOOK_APIS = (save_submit) => {
    const files = getFilesForUpload();
    set_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", atob(garbage_id));
    FORM_DATA.append("save_submit", Number(save_submit) || 0);
    FORM_DATA.append("voyage_id", recordVoyage);
    FORM_DATA.append("garbage_type", garbage_type);
    FORM_DATA.append("quantity_disposed", qtty_disposed);
    FORM_DATA.append("method_of_disposal", method_of_disposal);
    FORM_DATA.append("disposed", if_disposed === "yes" ? 1 : 0);
    FORM_DATA.append("comment", free_Text);
    FORM_DATA.append("request_type", "edit");
    FORM_DATA.append("log_date_time", logDateTimePayload(logDate, captureNow));
    FORM_DATA.append("garbage_part", "1");
    FORM_DATA.append("position", position);
    FORM_DATA.append("signature", digitalSignatureIncharge);
    files?.forEach((files) => {
      FORM_DATA.append("files", files);
    });

    post(ApiURL.garbage_record_details, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success Message", res?.message);
        navigate("/list-garbage-log");
        set_loader(false);
      } else {
        ErrorToast("Error message", res?.message);
        const errors = res?.errors || {};
        set_errors(errors);
        set_loader(false);
      }
    });
  };

  const GET_DUCS_URL = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = async (file) => {
    const url = GET_DUCS_URL(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  const reomveItem = async (file) => {
    const fileName = file.name;
    const FORM_DATA = new FormData();
    FORM_DATA.append("file_name", fileName);

    try {
      post(ApiURL.remove_garbage_file_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", "File removed successfully");
          VIEW_GARBAGE_LOGBOOK_APIS();
        } else {
          ErrorToast("Error", "Failed to remove file");
          console.error("Failed to remove file:", res?.message);
          return;
        }
      });
    } catch (error) {
      console.error("Error removing file:", error);
      ErrorToast("Error", "Failed to remove file");
      return;
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <br />
        <h3>Garbage Logbook Information </h3>
        <div className="row">
          <div className="col-6">
            <LogDateTimeInput value={logDate} onChange={set_LogDate}
              captureNow={captureNow} onCaptureChange={setCaptureNow}
              error={errors.log_date_time} disabled={!canEdit || submitStatus} />
          </div>
          <div className="col-6">
            <SelectInput
              disabled={!canEdit || submitStatus}
              label="Garbage Type"
              value={garbage_type}
              placeholder=" -- Garbage Type  -- "
              style={{ width: "100%" }}
              onChange={(value) => set_garbage_type(value)}
              options={garbageType}
              errors={errors?.selectedTank}
            />
          </div>
        </div>

        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-6">
            <label className="block-label">If disposed</label>
            <Radio.Group
              disabled={!canEdit || submitStatus}
              value={if_disposed}
              onChange={(e) => set_If_disposed(e.target.value)}
            >
              <Radio value={"no"}>NO</Radio>
              <Radio value={"yes"}>Yes</Radio>
            </Radio.Group>
            {errors?.voyage_status && (
              <span style={{ color: "red" }}>{errors?.voyage_status}</span>
            )}
          </div>
        </div>
        {if_disposed === "yes" && (
          <>
            <div className="row">
              <div className="col-6">
                <SelectInput
                  disabled={!canEdit || submitStatus}
                  label="Method of Disposal"
                  placeholder=" -- Method of Disposal  -- "
                  style={{ width: "100%" }}
                  value={method_of_disposal}
                  onChange={(value) => set_method_of_disposal(value)}
                  options={methodofDisposal}
                  errors={errors?.method_of_disposal}
                />
              </div>
              <div className="col-6">
                <AppInput
                  disabled={!canEdit || submitStatus}
                  label="Qnty disposed (m3)"
                  placeholder="Qnty disposed"
                  value={qtty_disposed}
                  onChange={(e) => set_qtty_disposed(e.target.value)}
                  errors={errors.qtty_disposed}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <AppInput
                  disabled={!canEdit || submitStatus}
                  label="Position"
                  placeholder="Enter Position"
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  errors={errors?.position}
                />
              </div>
              <div className="col-6">
                <AppInput
                  disabled={!canEdit || submitStatus}
                  label="Digital Signature (Incharge)"
                  placeholder="Enter Digital Signature"
                  value={digitalSignatureIncharge}
                  onChange={(e) => setDigitalSignatureIncharge(e.target.value)}
                  errors={errors?.digitalSignatureIncharge}
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>
                Garbage Comments: (e.g. start/stop time and position of
                incineration; general)
              </label>
              <TextArea
                rows={1}
                disabled={!canEdit || submitStatus}
                placeholder="Garbage Comments"
                maxLength={1000}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div
              className="input-box"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <label>Select File</label>
              <Upload
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                fileList={documentList}
                onChange={handleDocumentChange}
                onPreview={handlePreviews}
                beforeUpload={() => false}
                listType="picture"
                onRemove={reomveItem}
                disabled={!canEdit || submitStatus}
              >
                <Button
                  icon={<UploadOutlined />}
                  type="primary"
                  disabled={!canEdit || submitStatus}
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                ></Button>
              </Upload>
            </div>
          </div>
        </div>
        <div className="row">
          {canEdit && !soft_delete &&
            (user?.data?.designation === "Captain" && garbage_id && (
              <>
                <div
                  className="input-box"
                  style={{ marginLeft: "15px", marginTop: "15px" }}
                >
                  <Button
                    loading={loader}
                    disabled={!canEdit || submitStatus}
                    className="save_btn"
                    style={{ color: "white" }}
                    // onClick={() => UPDATE_GARBAGE_LOGBOOK_APIS("1")}
                    onClick={() => setModalVisible(true)}
                  >
                    Submit
                  </Button>
                </div>
              </>
            ))}
        </div>
        {canEdit && !submitStatus && !reviewed && (
          <Button loading={loader} type="primary" onClick={() => UPDATE_GARBAGE_LOGBOOK_APIS("0")}>Save Draft</Button>
        )}
        <SecurityCodeModal
          record_id={atob(garbage_id)}
          visible={modalVisible}
          setModalVisible={setModalVisible}
          onCancel={() => setModalVisible(false)}
          onSuccess={() => {
            UPDATE_GARBAGE_LOGBOOK_APIS("1");
            setModalVisible(false);
          }}
          apiEndPoint={ApiURL.verify_security_code_st}
        />
      </div>
    </>
  );
}

export default EditGarbageLog;
